import ApiService from '@/core/services/api.service';

export const SupplierGroupService = {
  /**
   * Get paginated supplier groups
   * @param {Object} params - Query parameters
   * @returns {Promise}
   */
  getAll(params = {}) {
    return ApiService.query('v1/supplier-groups', { params });
  },

  /**
   * Get supplier group by ID with details
   * @param {number} id - Supplier group ID
   * @param {Object} options - Additional options
   * @returns {Promise}
   */
  getById(id, options = {}) {
    const params = {
      includeParent: options.includeParent || false,
      includeChildren: options.includeChildren || false,
      includeSuppliers: options.includeSuppliers || true,
    };
    return ApiService.query(`v1/supplier-groups/${id}`, { params });
  },

  /**
   * Get all supplier groups without pagination
   * @param {Object} params - Query parameters
   * @returns {Promise}
   */
  getAllNoPagination(params = {}) {
    return ApiService.query('v1/supplier-groups/all', { params });
  },

  /**
   * Create new supplier group
   * @param {Object} data - Supplier group data
   * @returns {Promise}
   */
  create(data) {
    return ApiService.post('v1/supplier-groups', data);
  },

  /**
   * Bulk create supplier groups
   * @param {Array} data - Array of supplier group data
   * @returns {Promise}
   */
  bulkCreate(data) {
    return ApiService.post('v1/supplier-groups/bulk-create', {
      supplierGroups: data,
    });
  },

  /**
   * Update supplier group
   * @param {number} id - Supplier group ID
   * @param {Object} data - Updated data
   * @returns {Promise}
   */
  update(id, data) {
    return ApiService.put(`v1/supplier-groups/${id}`, data);
  },

  /**
   * Delete supplier group
   * @param {number} id - Supplier group ID
   * @returns {Promise}
   */
  delete(id) {
    return ApiService.delete(`v1/supplier-groups/${id}`);
  },

  /**
   * Bulk update supplier groups
   * @param {Array} updates - Array of update objects
   * @returns {Promise}
   */
  bulkUpdate(updates) {
    return ApiService.patch('v1/supplier-groups/bulk-update', { updates });
  },

  /**
   * Export supplier groups to Excel
   * @param {Object} params - Filter parameters
   * @returns {Promise}
   */
  exportToExcel(params = {}) {
    return ApiService.get('v1/supplier-groups/export-excel', {
      params,
      responseType: 'blob',
    });
  },

  /**
   * Import supplier groups from Excel
   * @param {FormData} formData - Form data containing the Excel file
   * @returns {Promise}
   */
  importFromExcel(formData) {
    return ApiService.post('v1/supplier-groups/import-excel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Download Excel template for import
   * @returns {Promise}
   */
  downloadTemplate() {
    return ApiService.get('v1/supplier-groups/template', {
      responseType: 'blob',
    });
  },
};
